import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminLocalOpticsStripeProducts = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/local_optics/stripe_products/index/index.vue')
    createVueApp(IndexPage, { props })
  },
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/local_optics/stripe_products/show/index.vue')
    createVueApp(ShowPage, { props })
  }
}
